module.exports = __webpack_public_path__ + "Roboto-Light-webfont.d8472f7b6012706fc028.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Light-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.ttf
// module chunks = styles